import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHookSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-108">
      <div className="max-w-2xl mx-auto" data-id="element-109">
        <FadeIn data-id="element-110">
          <p className="text-xl md:text-2xl leading-relaxed mb-6 font-serif italic text-brand-brown" data-id="element-111">
            Es viernes por la tarde. Recoges a tus hijos en el punto de
            encuentro o en casa de tu ex.
          </p>
          <p className="text-lg mb-6 leading-relaxed" data-id="element-112">
            El trayecto de vuelta en el coche es un silencio sepulcral o, peor
            aún, una serie de monosílabos que te hacen sentir como un extraño en
            su vida.
          </p>
          <p className="text-lg mb-6 leading-relaxed" data-id="element-113">
            Sientes que, aunque legalmente te toca estar con ellos,
            emocionalmente están a kilómetros de distancia.
          </p>
          <p className="text-lg leading-relaxed font-semibold text-brand-brown" data-id="element-114">
            Intentas conectar, preguntas "¿qué tal la semana?", y la respuesta
            es un muro de hormigón.
          </p>
        </FadeIn>
      </div>
    </section>;
}